var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Collapse",
    {
      staticClass: "po-info-collapse",
      attrs: { id: "id", title: _vm.title, expand: true, withBorder: false },
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog-bg",
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _c("div", { staticClass: "po-info__content" }, [
            _c("div", { staticClass: "po-info__left-block" }, [
              _c("div", { staticClass: "po-info__description" }, [
                _c("span", [_vm._v(_vm._s(_vm.purchaseOrder.description))]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "po-info__right-block" }, [
              _c("div", { staticClass: "po-info__amount" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("formatCurrency")(
                        _vm.roundAmount(_vm.purchaseOrder.amount),
                        { currencyCode: _vm.purchaseOrder.currencyCode }
                      )
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "po-info__created-by" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("project.purchaseOrder.createdBy")) +
                    ": " +
                    _vm._s(_vm.purchaseOrder.requestedBy) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.isTenderAward
            ? _c("AttachDocs", {
                ref: "attachPODocs",
                attrs: {
                  resourceId: _vm.purchaseOrder.poResourceId,
                  freezeDocTime: _vm.purchaseOrder.inviteDate,
                  btnName: _vm.attachBtnLabel,
                },
                on: { "update:attachments": _vm.updateAttachments },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }